import * as React from "react";
//import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

const betScore = [

  [160, 60],
  [180, 80],
  [200, 100],
  [250, 250],

];

export default function SimpleBet(props) {
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog
      style={{
        textAlign: "center",
        justifyContent: "center",
      }}
      onClose={handleClose}
      open={open}
    >
      <DialogTitle>Combien tu paries ?</DialogTitle>
      <List sx={{ pt: 0 }}>
        {betScore.map((bet, index) => (
          <ListItem key={index} disableGutters>
            <ListItemButton
              onClick={() => handleListItemClick(bet[0])}
              key={bet[0]}
              style={{
                textAlign: "center",
                justifyContent: "center",
                font: "none",
                paddingRight: "10px",
              }}
            >
              <ListItemText
                primary={bet[1] + " (" + bet[0] / 10 + "points) "}
                //primary={bet[0] / 10 + " points"}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}
/*
SimpleBet.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};
*/
